import {dictionaryApi} from 'common/api/entitiesApi'
import {DictionarySelector, DictionarySelectorProps} from './DictionarySelector'
import {FC} from 'react'

export const LanguageSelector: FC<DictionarySelectorProps> = ({ multiple, mode, ...props }) =>
    <DictionarySelector {...props} cacheKey="language" loader={() => dictionaryApi.language()}
                        errorText="Can't load available languages" mode={ multiple ? (mode ?? 'multiple') : undefined }/>